import React from 'react';
import { useNavigate } from 'react-router-dom';
import './RegistrationComplete.css'; // Make sure to create this CSS file for styling

const RegistrationComplete = () => {
  const navigate = useNavigate();

  const handleLoginRedirect = () => {
    navigate('/'); // Redirect to Login page
  };

  return (
    <div className="registration-complete-container">
      <div className="registration-complete-content">
        <h1 className="registration-complete-title">Registration Complete!</h1>
        <p className="registration-complete-message">
              Congratulations! You have successfully registered. Please log in to complete the rest of the registration process. 
              Remember to verify your email, and you can also verify your site upon login.
        </p>
        <button className="login-button" onClick={handleLoginRedirect}>
          Go to Login
        </button>
      </div>
    </div>
  );
};

export default RegistrationComplete;
